import { useEffect, useMemo, useState } from 'react';
import 'moment/locale/es';
import { useLocation, Outlet } from 'react-router-dom';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import './imprimirVisitaGrilla.scss';
import { ImprimirVisitaGrillaHeader } from './ImprimirVisitaGrillaHeader';
import { ImprimirVisitaGrillaFilters } from './ImprimirVisitaGrillaFilters';
import { usePersistFilters } from '../../../hooks/usePersistFilters';

export const ImprimirVisitaGrilla = ({ setChildrenAction }) => {

    const [allowedWrite, setAllowedWrite] = useState(false);
    const [delegaciones, setDelegaciones] = useState([]);
    const [tipoProfesionales, setTipoProfesionales] = useState([]);
    const [imprimirVisitasGrilla, setImprimirVisitasGrilla] = useState([]);
    const [imprimirVisitasGrillaLoading, setImprimirVisitasGrillaLoading] = useState(false);
    const [printLoading, setPrintLoading] = useState(false);
    const [documentosSeleccionados, setDocumentosSeleccionados] = useState([]);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [refetchGrilla, setRefetchGrilla] = useState(localStorage.getItem('ImprimirVisitaGrillaFilters') != null);

    const initialFilters = {
        fechaDesde: '',
        fechaHasta: '',
        idDelegacion: 0,
        idTipoProfesional: 0,
        txtFiltro: ''
    }

    const { filters, handleChangeFilters } = usePersistFilters(initialFilters, "ImprimirVisitaGrillaFilters");

    const location = useLocation();
    const rutasStorage = localStorage.getItem('navigationRoutes');

    useEffect(() => {
        if (rutasStorage) {
            const rutas = JSON.parse(rutasStorage);
            const rutaQueSirve = location.pathname;
            setAllowedWrite(rutas?.find(ruta => ruta.aplicaciones.find(app => app.url == rutaQueSirve)
            )?.aplicaciones?.find(app => app.url == rutaQueSirve).escritura);
        }
    }, [rutasStorage]);

    useEffect(() => {
        setChildrenAction(() => (
            <ImprimirVisitaGrillaHeader
                allowedWrite={allowedWrite}
                documentosSeleccionados={documentosSeleccionados}
                setPrintLoading={setPrintLoading}
            />
        ));
    }, [
        setChildrenAction,
        documentosSeleccionados,
        allowedWrite
    ]);

    const handleSelectionModelChange = (ids) => {
        setRowSelectionModel(ids);
        if (ids.length > 0) {
            setDocumentosSeleccionados(imprimirVisitasGrilla.filter((row, index) => {
                return ids.includes(index + 1);
            }));
        } else {
            setDocumentosSeleccionados([]);
        }
    }

    const initialColumns = [
        {
            field: 'idVisita',
            headerName: '#',
            flex: 0.12
        },
        {
            field: 'tipoDocumento',
            headerName: 'Tipo',
            flex: 0.14
        },
        {
            field: 'estadoCoordinacion',
            headerName: 'Estado',
            flex: 0.18
        },
        {
            field: 'fecha',
            headerName: 'Fecha',
            width: 80
        },
        {
            field: 'tipoVisita',
            headerName: 'Forma',
            flex: 0.15
        },
        {
            field: 'idPaciente',
            headerName: 'HC',
            width: 60
        },
        {
            field: 'paciente',
            headerName: 'Paciente',
            flex: 0.4
        },
        {
            field: 'edad',
            headerName: 'Edad',
            width: 60
        },
        {
            field: 'profesional',
            headerName: 'Profesional',
            flex: 0.4
        },
        {
            field: 'idEvaluacion',
            headerName: 'Contrato',
            width: 75
        },
        {
            field: 'cobertura',
            headerName: 'Cobertura',
            flex: 0.30
        },
        {
            field: 'programa',
            headerName: 'Programa',
            flex: 0.16
        }
    ];

    const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [filters, allowedWrite]);

    const defineRowSelectable = (params) => {
        if (params.row?.estadoCoordinacion?.includes('No Liberada')) {
            return false;
        }
        return true;
    }

    return (
        <>
            <div>
                <ImprimirVisitaGrillaFilters
                    delegaciones={delegaciones}
                    tipoProfesionales={tipoProfesionales}
                    filters={filters}
                    printLoading={printLoading}
                    setImprimirVisitasGrilla={setImprimirVisitasGrilla}
                    setImprimirVisitasGrillaLoading={setImprimirVisitasGrillaLoading}
                    setDelegaciones={setDelegaciones}
                    setTipoProfesionales={setTipoProfesionales}
                    handleChangeFilters={handleChangeFilters}
                    refetchGrilla={refetchGrilla}
                    setRefetchGrilla={setRefetchGrilla}
                />
                <br />
                <DataGridGenerico
                    columns={columns}
                    rows={imprimirVisitasGrilla}
                    toolbar={false}
                    checkboxSelection={true}
                    rowSelectionModel={rowSelectionModel}
                    onRowSelectionModelChange={(e) => handleSelectionModelChange(e)}
                    loading={imprimirVisitasGrillaLoading}
                    isRowSelectable={defineRowSelectable}
                />
            </div>

            <Outlet />
        </>
    )
}